<template> 

<div>

   

<div v-for="item in this.emprestimo" v-bind:key="item._id" :class="'loans-details rating-'+lowerCase(item.Score)">
    <!-- título dá página/voltar -->
        <div class="row tit_page">
            <div class="col-12">
                <div class="float-left">
                    <h1>
                        Meus empréstimos
                        <span>{{ajustIdOportunidade(item.IdOportunidade, 5)}}</span>
                        <strong>{{formatted(item.Documento)}}</strong>
                    </h1>
                </div>

                <!--Frame robinacademia -->
                <iframe :src="'https://robinacademia.com/p.ashx?o=90&e=10&f=pb&t='+item.IdOportunidade" height="1" width="1" frameborder="0"></iframe>
                <!--Frame robinacademia -->

                <div class="options float-right">
                    <a v-if="!sms" @click="$router.go(-1)" href="javascript:;" title="Voltar">
                        <i class="back">&nbsp;</i> 
                        <span>Voltar</span>
                    </a>
                    <a v-if="sms" @click="$router.push('/emprestimos/meus-emprestimos')" href="javascript:;" title="Voltar">
                        <i class="back">&nbsp;</i> 
                        <span>Voltar</span>
                    </a>
                </div>
                <div class="clearfix"></div>
            </div>
        </div>
        <!-- final título dá página/voltar -->

        <hr class="divider">

       <div class="row" v-if="VerificaStatus(item)">
            <!-- inicio detalhes proposta -->
            <div class="col-12 col-md-7 col-lg-8">
                <section>

                    <div class="tit">
                        <div class="float-left">
                            <h3>Dados financeiros</h3>
                        </div>
                        <div class="float-right rating">
                            <strong>Score da operação <span class="circle score"></span> {{formatarScore(item.Score)}}</strong>
                        </div>
                        <div class="clearfix"></div>
                    </div>

                    <div class="row">
                        <div class="col-12 col-md-6 col-lg-4 col-xl-4">
                            <div class="box">
                                <label>Valor Solicitado</label>
                                <p>R$ {{(item.ValorSolicitado != undefined && item.ValorSolicitado != 0)? money(item.ValorSolicitado) : money(item.Valor)}}</p>
                            </div>
                        </div>
                        <div class="col-12 col-md-6 col-lg-4 col-xl-4">
                            <div class="box">
                                <label>Valor Aprovado</label>
                                <p>R$ {{money(item.Valor)}}</p>
                            </div>
                        </div>
                        <div class="col-12 col-md-6 col-lg-4 col-xl-4">
                            <div class="box">
                                <label>Duração</label>
                                <p>{{item.Prazo}} meses</p>
                            </div>
                        </div>
                        <div class="col-12 col-md-6 col-lg-4 col-xl-4">
                            <div class="box">
                                <label>Valor da parcela</label>
                                <p>R$ {{money(item.ValorParcela)}}</p>
                            </div>
                        </div>
                        <div v-if="item.TipoEmprestimo != 'emprestimo-social'" class="col-12 col-md-6 col-lg-4 col-xl-4">
                            <div class="box">
                                <label>Valor total do empréstimo</label>
                                <p>R$ {{money(Total(item.Prazo, item.ValorParcela))}}</p>
                            </div>
                        </div>
                        <div v-if="item.TipoEmprestimo != 'emprestimo-social'" class="col-12 col-md-6 col-lg-4 col-xl-4">
                            <div class="box">
                                <label>Juros</label>
                                <p>{{item.TaxaJuros == undefined ?"-":money(item.TaxaJuros)+ "% a.m"}}</p>
                            </div>
                        </div>
                        <div v-if="item.TipoEmprestimo != 'emprestimo-social'" class="col-12 col-md-6 col-lg-4 col-xl-4">
                            <div class="box">
                                <label>Taxa total efetiva</label>
                                <p>{{money(item.Rendimento)}}% a.a.</p>
                            </div>
                        </div>
                        <div v-if="item.CustoEfetivoTotalam != undefined && item.CustoEfetivoTotalam != 0 && item.TipoEmprestimo != 'emprestimo-social'" class="col-12 col-md-6 col-lg-4 col-xl-4">
                            <div class="box">
                                <label>Custo Efetivo Total</label>
                                <p>{{item.CustoEfetivoTotalam == undefined ?"-":money(item.CustoEfetivoTotalam)+ "% a.m." }}</p>
                            </div>
                        </div>
                        <div v-if="item.CustoEfetivoTotalaa != undefined && item.CustoEfetivoTotalaa != 0 && item.TipoEmprestimo != 'emprestimo-social'" class="col-12 col-md-6 col-lg-4 col-xl-4">
                            <div class="box">
                                <label>Custo Efetivo Total</label>
                                <p>{{item.CustoEfetivoTotalaa == undefined ?"-":money(item.CustoEfetivoTotalaa)+ "% a.a." }}</p>
                            </div>
                        </div>
                        <div v-if="item.Iof != undefined && item.Iof != 0 && item.TipoEmprestimo != 'emprestimo-social'" class="col-12 col-md-6 col-lg-4 col-xl-4">
                            <div class="box">
                                <label>IOF</label>
                                <p>R$ {{item.Iof == undefined ?"-":money(item.Iof)}}</p>
                            </div>
                        </div>
                        <div v-if="item.TaxaIouu != undefined && item.TaxaIouu != 0" class="col-12 col-md-6 col-lg-4 col-xl-4">
                            <div class="box">
                                <label>Taxa IOUU</label>
                                <p>R$ {{item.TaxaIouu == undefined ?"-":money(item.TaxaIouu)}}</p>
                            </div>
                        </div>
                        <div v-if="item.TaxaParceira != undefined && item.TaxaParceira != 0 && item.TipoEmprestimo != 'emprestimo-social'" class="col-12 col-md-6 col-lg-4 col-xl-4">
                            <div class="box">
                                <label>Taxa Instituição Financeira</label>
                                <p>R$ {{item.TaxaParceira == undefined ?"-":money(item.TaxaParceira)}}</p>
                            </div>
                        </div>
                        <div v-if="item.ValorLiquido != undefined && item.ValorLiquido != 0 && item.TipoEmprestimo != 'emprestimo-social'" class="col-12 col-md-12 col-lg-12">
                            <div class="box">
                                <label>Valor Liquido a Receber</label>
                                <p>R$ {{money(item.ValorLiquido)}}</p>
                            </div>
                        </div>
                         <div v-if="item.ValorLiquido != undefined && item.ValorLiquido != 0 && item.TipoEmprestimo == 'emprestimo-social'" class="col-12 col-md-6 col-lg-4 col-xl-4">
                            <div class="box">
                                <label>Valor Liquido a Receber</label>
                                <p>R$ {{money(item.ValorLiquido)}}</p>
                            </div>
                        </div>
                    </div>
                </section>

                <section>
                    <div class="tit">
                        <h3>Dados da Empresa</h3>
                    </div>
                    <div class="row">
                        <div class="col-12 col-lg-6" v-if="item.CodProduto != 'EMPSOC'">
                            <label>Empresa <span>(Razão social) empresa</span></label>
                            <span>{{item.Empresa.RazaoSocial}}</span>
                        </div>
                        <div class="col-12 col-lg-6" v-if="item.CodProduto == 'EMPSOC' && item.TipoPessoa == 'pessoa juridica'">
                            <label>Empresa <span>(Razão social)</span></label>
                            <span>{{item.Social.RazaoSocial}}</span>
                        </div>
                        <div class="col-12 col-lg-6" v-if="item.CodProduto == 'EMPSOC' && item.TipoPessoa == 'pessoa fisica'">
                            <label>Empresa</label>
                            <span>{{item.Social.NomeCompleto}}</span>
                        </div>
                        <div class="col-12 col-lg-3">
                            <label>CPF/CNPJ</label>
                            <span>{{formatted(item.Documento)}}</span>
                        </div>
                        <div class="col-12 col-lg-3" v-if="item.CodProduto != 'EMPSOC'">
                            <label>Nome do responsável</label>
                            <span>{{formatenome(item.Solicitante.NomeCompleto)}}</span>
                        </div>
                        <div class="col-12 col-lg-3" v-if="item.CodProduto == 'EMPSOC'">
                            <label>Nome do responsável</label>
                            <span>{{formatenome(item.Social.NomeCompleto)}}</span>
                        </div>
                    </div>                 
                </section>
            </div>
            <!-- final detalhes proposta -->

            <!-- inicio aceite proposta -->
            <aside class="col-12 col-md-5 col-lg-4">
                <div class="box">

                    <!-- inicio aceite/rejeite proposta -->
                    <div class="content" v-if="!aceite">
                        <h3>{{formatenome(item.Nome)}}, sua solicitação de empréstimo foi aprovada.</h3>
                        <p>Falta pouco, agora você deve aceitar a proposta para darmos andamento na sua captação.</p>

                        <form>
                            <ul>
                                <li>
                                   <!-- <label class="accept ">
                                        <input type="checkbox" >
                                        <span>Sim, aceito as condições propostas para minha solicitação de empréstimo.</span>
                                    </label> -->
                                    <div class="form-check d-flex justify-content-center">
                                        <div class="checkboxContainer">
                                            <input type="checkbox" class="form-check-input" id="noOther" v-model="concordo">
                                            <span class="checkmark"></span>
                                        </div>
                                         <label class="accept" for="noOther"><span>Sim, aceito as condições propostas para minha solicitação de empréstimo.</span></label>
                                    </div>
                                </li>
                            </ul>

                            <button type="button" class="btn btn-lg btn-primary btn-block" :disabled="!concordo" @click="aceite = true;" >Sim, aceito os termos</button>
                            <button type="button" class="btn btn-lg btn-link btn-block" @click="rejeita = true; aceite = true;">Não aceito a proposta</button>
                        </form>
                    </div>
                    <!-- final aceite/rejeite proposta -->

                    <!-- inicio steps proposta aceita -->
                    <div class="content" v-if="aceite && !rejeita">

                        <!-- inicio step senha -->
                        <div id="password" v-if="!confirmasenha">
                            <p>Por favor insira sua senha no campo abaixo para formalizar sua solicitação de empréstimo.</p>

                            <form @submit.prevent="ConfirmaSenha">
                                <div class="form form-group">
                                    <input type="password" class="form-control" id="password" placeholder="Sua senha aqui" v-model="password">
                                </div>

                                <button class="btn btn-lg btn-primary btn-block" :disabled="password == ''">Confirmar solicitação</button>
                                <button type="button" class="btn btn-lg btn-link btn-block" @click="aceite = false; concordo = false;">Cancelar</button>
                            </form>
                        </div>
                        <!-- final step senha -->

                        <!-- inicio step token sms -->
                        <div id="token-sms" v-if="confirmasenha && !sms">
                            <h3>{{formatenome(item.Nome)}}, falta só mais um passo!</h3>
                            <p>Por favor insira o código enviado por SMS para o seu telefone celular.</p>

                            <form @submit.prevent="CheckSms">
                                <div class="form form-group">
                                    <input type="text" class="form-control " id="sms" placeholder="Código SMS" v-model="smsToken">
                                </div>

                                <button class="btn btn-lg btn-primary btn-block" :disabled="smsToken == ''">Autorizar</button>
                                <button type="button" class="btn btn-lg btn-link btn-block" @click="aceite = false; concordo = false; confirmasenha = false;">Cancelar</button>
                            </form>
                        </div>
                        <!-- final step token sms -->

                        <!-- inicio step proposta aceita-->
                        <div id="confirmacao-aceite" v-if="sms">
                            <h3>{{formatenome(item.Nome)}}, parabéns!</h3>
                            <p>Seu aceite foi concluído com sucesso.<br>
                            Em breve sua proposta estará cadastrada na plataforma para captação.</p>
                        </div>
                        <!-- final step proposta aceita -->

                    </div>
                    <!-- final steps proposta aceita -->


                    <!-- inicio step proposta rejeitada -->
                    <div class="content"  v-if="rejeita">
                        <!-- inicio step inicial -->
                        <div id="opcoes" v-if="!checkmotivo" >
                            <h3>{{formatenome(item.Nome)}}, tem certeza que deseja rejeitar a proposta?</h3>
                            <p>Por favor, liste abaixo os motivos da não aprovação da proposta.</p>

                            <form @submit.prevent="RecusaEmprestimo">
                                <ul>
                                    <li>
                                        <div class="form-check d-flex justify-content-left">
                                            <div class="checkboxContainer">
                                                <input type="checkbox" class="form-check-input" id="noOther" v-model="prazo">
                                                <span class="checkmark"></span>
                                            </div>
                                            <label class="accept" for="noOther"><span>Prazo de pagamento</span></label>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="form-check d-flex justify-content-left">
                                            <div class="checkboxContainer">
                                                <input type="checkbox" class="form-check-input" id="noOther" v-model="parcela">
                                                <span class="checkmark"></span>
                                            </div>
                                            <label class="accept" for="noOther"><span>Valor da parcela</span></label>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="form-check d-flex justify-content-left">
                                            <div class="checkboxContainer">
                                                <input type="checkbox" class="form-check-input" id="noOther" v-model="juros">
                                                <span class="checkmark"></span>
                                            </div>
                                            <label class="accept" for="noOther"><span>Taxa de juros</span></label>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="form-check d-flex justify-content-left">
                                            <div class="checkboxContainer">
                                                <input type="checkbox" class="form-check-input" id="noOther" v-model="condicoes">
                                                <span class="checkmark"></span>
                                            </div>
                                            <label class="accept" for="noOther"><span>Condições gerais</span></label>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="form-check d-flex justify-content-left">
                                            <div class="checkboxContainer">
                                                <input type="checkbox" class="form-check-input" id="noOther" v-model="outros">
                                                <span class="checkmark"></span>
                                            </div>
                                            <label class="accept" for="noOther"><span>Outros</span></label>
                                        </div>
                                    </li>
                                    <li class="outros" v-if="outros">
                                        <div class="form-group">
                                            <input type="text" v-model="motivo" class="form-control" placeholder="Informe o motivo...">
                                        </div>
                                    </li>
                                </ul>
                                <button class="btn btn-lg btn-primary btn-block" :disabled="!prazo && !parcela && !juros && !condicoes && (!outros || motivo == '') ">Não aceito a proposta</button>
                                <button type="button" class="btn btn-lg btn-link btn-block" @click=" aceite = false; rejeita = false">Cancelar</button>
                            </form>
                        </div>
                        <!-- final step inicial -->

                        <!-- inicio step proposta aceita-->
                        <div id="confirmacao-rejeite" v-if="checkmotivo">
                            <h3>Obrigado, {{formatenome(item.Nome)}}.</h3>
                            <p>Estareamos a disposição a qualquer momento.</p>
                        </div>
                        <!-- final step proposta aceita -->

                    </div>
                    <!-- final step proposta rejeijtada -->

                </div>
            </aside>
            <!-- final aceite proposta -->

        </div>
        <!-- final exibe proposta -->

</div>
</div>
</template>

<style lang="scss" scoped>
    @import "../assets/styles/iouu/variables";
    @import "../assets/styles/iouu/mixins";
   
    .tit_page {
        h1 {
            line-height: 20px;
            span {
                float:none;
            }
            strong {
                float:none;
            }
        }
        @include ds {
            h1 {
                @include font-size(25px);
            }

            span, strong {
                @include font-size(16px);
            }

            .back {
                a {
                    line-height: 20px;
                    margin: 5px 0;

                    span {
                        font-size: 12px;
                    }
                }
            }
        }
    }

    hr {
        @include ds {
            margin-top: 10px;
            margin-bottom: 10px;
        }
    }

    section {
        @include ds {

            .tit {
                margin-bottom:18px;
                padding-bottom: 10px;
            }
            .box {
                padding: 10px;
                margin-bottom: 15px;
            }
        }
    }

    aside {
        .box {
            border-left:1px solid #ddd!important;
            margin-bottom:0px!important;
            display: flex;
            justify-content: center;
            align-items: center;
            height: 100%;
        }

        .content {
            text-align:center;

            h3 {
                @include font-size(25px);
                @include line-height(25px);
                padding-bottom: 20px;
            }

            p {
                @include font-size(16px);
                @include line-height(16px);
                font-weight: normal;
                color: #999;
            }

            @include ds {
                h3 {
                    @include font-size(20px);
                    @include line-height(20px);
                }

                p {
                    @include font-size(13px);
                    @include line-height(13px);
                }
            }
        }

        ul {
            text-align: left;
            margin: 40px 0 40px;

            li {
                input[type=text] {
                    height: auto;
                    @include font-size(16px);
                    text-align: left;
                }
            }

            label {
                &.accept {
                    display: flex;
                    span {
                        @include font-size(12px);
                        display: table;
                    }
                }
            }

            span {
                font-weight: normal;
            }

            @include ds {
                margin: 30px 0 30px;

                li {
                    input[type=text] {
                        @include font-size(14px);
                    }
                }
                label {
                    &.accept {
                        @include font-size(12px);
                        @include line-height(15px);
                    }
                }
            }
        }

        form {
            input[type=checkbox] {
                height: auto;

                &:focus,
                &.focus {
                    outline:none;
                    outline-offset: 0px;
                }
            }

            .form {
                margin-top: 30px;

                input[type=password] {
                    @include font-size(18px);
                    height: 50px;
                }
                input[type=text] {
                    @include font-size(18px);
                    height: 50px;
                }

                @include ds {
                    input[type=password] {
                        @include font-size(15px);
                        height: 40px;
                    }
                    input[type=text] {
                        @include font-size(15px);
                        height: 40px;
                    }
                }
            }

            .btn {
                height: 50px;

                &-primary {
                    @include font-size(18px);

                    &.focus,
                    &:focus {
                        box-shadow: none;
                    }
                    
                    &.disabled,
                    &:disabled {
                        background-color: #ccc;
                        border: none;
                        cursor: default;
                        &:hover {
                            background-color: #ccc;
                        }
                    }
                }

                &-link {
                    @include font-size(18px);
                    text-transform: initial;
                    font-weight: normal;
                    color: #999;

                    &:hover {
                        color: #666;
                    }
                }

                @include ds {
                    height: 40px;

                    &-primary {
                        @include font-size(15px);
                    }
                    &-link {
                        @include font-size(15px);
                    }
                }
            }
        }
    }

    // CHECKBOX - CUSTOM 
	.checkboxContainer {
		&{
		  display: block;
		  position: relative;
		  cursor: pointer;
		  -webkit-user-select: none;
		  -moz-user-select: none;
		  -ms-user-select: none;
			user-select: none;
			width: 25px;
			height: 25px;
			margin-right: 10px;
    }
    
		&:hover {
		  input ~ .checkmark {
			background-color: #ccc;
		  }
		}
	
		input {
		  position: absolute !important;
		  opacity: 0;
		  width: 25px;
		  height: 25px;
		  cursor: pointer;
			left: 0;
      margin-left: 0;
      top: -4px;
	
		  &:checked ~ .checkmark {
			background-color: #41D3BF;
		  }
		}
	
		.checkmark {
		  position: absolute;
		  top: -4px;
		  left: 0;
		  height: 25px;
		  width: 25px;
		  background-color: #eee;
		  border-radius: 6px;
		  cursor: pointer;
		  pointer-events: none;
	
		  &::after {
			content: "";
			position: absolute;
			display: none;
			left: 9px;
			top: 5px;
			width: 8px;
			height: 13px;
			border: solid white;
			border-width: 0 3px 3px 0;
			-webkit-transform: rotate(45deg);
			-ms-transform: rotate(45deg);
			transform: rotate(45deg);
		  }
	
		}
	
		input:checked ~ .checkmark:after {
		  display: block;
		}
	}
	// END CHECKBOX - CUSTOM
</style>

<script>
import Modal from "@/components/Modal";
import * as mutationTypes from "@/store/mutation-types.js";
import ApiClient from "@/utils/api-client";
import Masker from "@/utils/masker";
import ArrayHelper from "@/utils/array-helper";
import BndesService from '../services/api/bndes';

export default {
  data() {
    return {
      emprestimo: null,
      id: '',
      concordo: false,
      aceite: null,
      confirmasenha: false,
      sms:  false,
      smsToken: '',
      rejeita: false,
      checkmotivo: false,
      prazo: false,
      parcela: false,
      juros: false,
      condicoes: false,
      outros: false,
      motivo: '',
      password: '',
      tentativas: 3,
      status: '',
    };
  },
  methods: {
    ConfirmaSenha: function(e) {
        const query = this.$route.query
        this.id = this.User._id; 
        ApiClient.VerificaSenha(this)
        .then(() => {
            //Chama a api para enviar o token sms para o cliente
            ApiClient.post('enviar-token-sms', {data: {SolicitacaoId: this.emprestimo[0]._id, AttemptNumber: 2, ConfirmaCliente: true}})
                .then(() => {
                    this.$Notify.info("SMS enviado com sucesso!")
                    this.confirmasenha = true;
                    this.tentativas = 3;
                })
                .catch(() => {
                    this.$Notify.error("Erro ao enviar o token SMS! Por favor verificar o número de celular!")
                })
        })
        .catch(() => {
            //Verificação do password
            this.password = ''
            this.tentativas --
            if(this.tentativas == 0) {
                this.$router.push("/login")
                this.$Notify.error("Erro: Você excedeu o número de tentativas limite!")
            }
            if(this.tentativas != 0)
                this.$Notify.error("Erro: Senha Inválida! Tentativas restantes: " + this.tentativas)
        });
    },
    RecusaEmprestimo: function (e) {  
        //Função que trata da negação do cliente
        this.checkmotivo = true;
        this.status = "Negado cliente"

        var motivo = ""
        if (this.prazo)
            motivo = motivo + " Prazo"
        if (this.parcela)
            motivo = motivo + " Parcela"
        if (this.juros)
            motivo = motivo + " Juros"
        if (this.condicoes)
            motivo = motivo + " Parcela"
        if (this.outros)
            motivo = motivo + " Outros:" + this.motivo

        const query  = this.$route.query;
        ApiClient.atualizaStatus(query.id, this.status, motivo)
        .then(() => {
            //Chama a api para "deletar" a notificação de "solicitação aprovada"
            ApiClient.AlteraStatusNotificacao(this.User._id ,query.id, "Deletado")
            .then(async() => {
                const resposta = await BndesService.AtualizaPropostaBndes({data: {SolicitacaoId: this.emprestimo[0]._id, Status: 'CANCELADA'}});
                    
                this.$Notify.info("Proposta Negada!")
            }).catch(() =>{
                this.$Notify.error("Erro ao Negar a Proposta!")
            })
        })
    },
    CheckSms: function (e) { 
        //Chama a api para checkar se o token informado é válido
        ApiClient.post('checar-token-sms', {data: {TokenConfirmacao: this.smsToken, SolicitacaoId: this.emprestimo[0]._id}})
        .then(() => {
            //Fazer a checkagem do Token de sms e então ... -->
            this.sms = true;
            this.status = "Aprovado cliente"
            const query = this.$route.query
            ApiClient.atualizaStatus(query.id, this.status, " ")
            .then(() => {
                //Chama a api para "deletar" a notificação de "solicitação aprovada"
                ApiClient.AlteraStatusNotificacao(this.id ,query.id, "Deletado")
                .then(() => {
                    this.$Notify.info("Proposta Aprovada com Sucesso!")
                })
            })
        })
        .catch(() => {
            this.tentativas --;
             if(this.tentativas == 0) {
                this.$router.push("/login")
                this.$Notify.error("Erro: Você excedeu o número de tentativas limite!")
            }
            if(this.tentativas != 0)
                this.$Notify.error("Erro: Token Inválido! Tentativas restantes: " + this.tentativas)
        })
    },
    Total(prazo, valor) 
    {
        return prazo * valor;
    },  
    VerificaStatus(emprestimo)
    {
        if(emprestimo.StatusAnalise == "Aprovado cliente")
        {
            this.sms = true;
            this.aceite = true;
            this.confirmasenha = true;
        } else if (emprestimo.StatusAnalise == "Negado cliente") {
            this.aceite = true;
            this.rejeita = true;
            this.checkmotivo = true;
        }
        
        return true;
    
    },
    formatted(doc)
    {
        doc = doc.replace(/\D/g, '')
        
        if(doc.length > 12)
        return Masker.maskCnpj(doc)

        return Masker.maskCpf(doc)
    },
    formatenome(nome)
    {
        nome = nome != null ? nome.trim() : "";
        if(nome.indexOf(" ") != -1)
        {
            nome = nome.split(" ")[0]
            return nome.substring(0,1).toUpperCase() +  nome.substring(1);
        }

        return nome.substring(0,1).toUpperCase() +  nome.substring(1);
    },
    formatarScore(score) {

      if(score == null)
        return "-";

      if(score.length > 1 && !isNaN(score[1])) {
        return score[0];
      }

      return score == ""?"-":score;
    },
    money(n) {
      var c = 2,
        d = ",",
        t = ".",
        s = n < 0 ? "-" : "",
        i = String(parseInt((n = Math.abs(Number(n) || 0).toFixed(c)))),
        j = (j = i.length) > 3 ? j % 3 : 0;
      return (
        s +
        (j ? i.substr(0, j) + t : "") +
        i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) +
        (c
          ? d +
            Math.abs(n - i)
              .toFixed(c)
              .slice(2)
          : "")
      );
    },
    lowerCase(texto) {
      if (texto == null || texto == undefined || texto == "") return "";

      if (texto == "AA" || texto == "HR") return texto.toLowerCase();

      return texto[0].toLowerCase();
    },
    ajustIdOportunidade(id, qtd) {
      var s = String(id);
  
     if(id == undefined || id == 0)
     return "";

      while (s.length < (qtd || 2)) {
        s = "0" + s;
      }
      return "#"+s;
    },
        //tagueamento GA
        taggingGA() {
            this.$ga.page({
                page: '/emprestimos/pre-aprovado-detalhes',
                title: 'pre-aprovado-detalhes',
            })
        },
    },
        computed: {
            //Retorna os dados do usuário que está acessando em um objeto 'User'
            User: function() {
            return this.$store.state.currentUser;
            },
        },
        components: { Modal },
        beforeCreate() {
            this.$store.commit(mutationTypes.START_LOADING);
            const query = this.$route.query;
            //Retorna o empréstimo de acordo com o ID em um objeto 'emprestimo'
            ApiClient.GetMeuEmprestimo(query.id)
            .then(response => {
                this.emprestimo = response;
                window.emprestimo = this.emprestimo;
                this.$store.commit(mutationTypes.STOP_LOADING)
            })
            .catch(() => this.$store.commit(mutationTypes.STOP_LOADING));
    },
    async created() {
        //tagueamento GA
        await this.taggingGA();
    }
};
</script>


// WEBPACK FOOTER //
// src/views/PreapprovedDetails.vue